import React from 'react';

const TeamIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none">
    <path d="M6 7C7.65685 7 9 5.65685 9 4C9 2.34315 7.65685 1 6 1C4.34315 1 3 2.34315 3 4C3 5.65685 4.34315 7 6 7ZM13 7.5C14.3807 7.5 15.5 6.38071 15.5 5C15.5 3.61929 14.3807 2.5 13 2.5C11.6193 2.5 10.5 3.61929 10.5 5C10.5 6.38071 11.6193 7.5 13 7.5ZM6 8.5C3.23858 8.5 1 10.0147 1 12V13H11V12C11 10.0147 8.76142 8.5 6 8.5ZM13 9C12.4 9 11.85 9.08 11.36 9.22C12.36 10.04 13 11.14 13 12V13H17V12C17 10.34 15.21 9 13 9Z" fill="#FFFFFF"/>
  </svg>
);

export default TeamIcon;
